import { Data } from '../components/ParticipantRecluitment/shared/types/PartnerConsentedParticipantData.types';
import { partnerClient } from '@modules/core/services';
import { FetchPartnerConsentParams } from '@modules/study-insights/components/ParticipantRecluitment/shared/types/participants.types';

export const fetchPartnerConsentedParticipantsData = async ({
  endDate,
  startDate,
  groupKey,
}: FetchPartnerConsentParams): Promise<Data | undefined> => {
  return await partnerClient.get(`recruitment/partner-consent-participants`, {
    params: {
      endDate,
      startDate,
      groupKey,
    },
  });
};
